import { Locale } from "next-intl"

export function local<T>(
    locale: Locale,
    values?: { [locale in Locale]?: T | null } | null,
  ) {
    if (!values) return undefined
    return values[locale] || values.de || undefined
  }
  